// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.X1NPr7esgMIWaNUC6K_h{width:100%}.klPGARhHT4g4aHMCWRAo{margin-top:40px;margin-bottom:24px;display:inline-block}.VNt0BR2P7Lo5NQy7JjdE{gap:12px;display:flex}.ZYaeT6IyogA6PWdTC_DT{align-items:flex-start;margin-top:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `X1NPr7esgMIWaNUC6K_h`,
	"sectionTitle": `klPGARhHT4g4aHMCWRAo`,
	"nameRow": `VNt0BR2P7Lo5NQy7JjdE`,
	"consent": `ZYaeT6IyogA6PWdTC_DT`
};
export default ___CSS_LOADER_EXPORT___;
